//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    submitQuery: function submitQuery() {
      this.$emit('submit');
    },
    cancelHandle: function cancelHandle() {
      this.$emit('cancel');
    }
  }
};